import { useContext } from "react";

import { AppModeContextType } from "@models/components/kiosk.model";

import AppModeContext from "./AppModeContext";

export const useAppMode = (): AppModeContextType => {
  const context = useContext(AppModeContext);
  if (context === undefined) {
    throw new Error("useAppMode must be used within an AppModeProvider");
  }
  return context;
};
